import { FC } from "react"
import cn from "classnames"

import { getAssetStatusLabel, AssetStatus } from "models/Asset"
import Text from "components/Text/Text"

function getAssetStatusBadgeClass(status: AssetStatus) {
    return {
        [AssetStatus.ordered]: 'bg-purple-400 color-white',
        [AssetStatus.confirmed]: 'bg-brand-yellow color-black',
        [AssetStatus.available]: 'bg-white color-green-500 border-green-500',
        [AssetStatus.active]: 'bg-green-500 color-white',
        [AssetStatus.inactive]: 'bg-grey-400 color-white',
    }[status]
}

interface IAssetStatusTagProps {
    status: AssetStatus
}

const AssetStatusTag: FC<IAssetStatusTagProps> = ({
    status,
}) => {
    const text = getAssetStatusLabel(status)
    const className = getAssetStatusBadgeClass(status)
    return (
        <Text type="pSmallest" className={cn("px-1 font-bold round-sm d-inline-block", className)}>
            {text}
        </Text>
    )
}

export default AssetStatusTag
